import { render, staticRenderFns } from "./CurrencyInputNumber.vue?vue&type=template&id=2fccf8f2&scoped=true&"
import script from "./CurrencyInputNumber.vue?vue&type=script&lang=js&"
export * from "./CurrencyInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fccf8f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
